import { useState } from "react";
import toast from "react-hot-toast";
import {
  UserFilters,
  useGetAllUsersQuery,
  useSetUserActivationMutation,
  useSendProgramReminderMutation
} from "../../api/endpoints/usersApi";

const useAllUsers = () => {
  const [filters, setFilters] = useState<UserFilters>({
    limit: 5
  });

  const { data, isError, isLoading } = useGetAllUsersQuery(filters);
  const [setUserActivation] = useSetUserActivationMutation();
  const [sendProgramReminder] = useSendProgramReminderMutation();

  /**
   * Attempts to update the given users "approved" status.
   */
  const updateUserStatus = (id: number, isApproved: boolean) => {
    const loader = toast.loading("Processing...");

    setUserActivation({ userId: id, isApproved }).then(res => {
      toast.remove(loader);

      if ("error" in res) {
        toast.error(`Failed to ${isApproved ? "activate" : "deactivate"} user`);
      } else {
        toast.success(`${isApproved ? "Activated" : "Deactivated"} user`);
      }
    });
  };



  /**
   * Sends a polite reminder email to create a program to the specified user
   */
  const remindToCreateProgram = (id: number) => {
    const loader = toast.loading("Sending reminder...");
    sendProgramReminder({ userId: id }).then(res => {
      toast.remove(loader);
      if ("error" in res) {
        toast.error("Failed to send reminder");
      } else {
        toast.success("Reminder sent");
      }
    });
  };

  return {
    users: data?.users || [],
    count: data?.count || 0,
    filters,
    isError,
    isLoading,
    setPage: (page: number) => setFilters(filters => ({ ...filters, page })),
    setFilters,
    updateUserStatus,
    remindToCreateProgram
  };
};

export default useAllUsers;
